/* global L */
import angular from 'angular';

// ES6 modules are strict by default
const levelsMapService = angular.module('applicationModule.levelsMapService', []);

/**
 * @ngdoc interface
 * @name applicationModule.mapServices.interface:LevelsMapService
 * @description
 * Service for handling map changes for: Levels.
 */
levelsMapService.service('LevelsMapService', ['$rootScope', 'MapService', function ($rootScope, MapService) {
    'use strict';
    var LevelsMapService = angular.extend({}, MapService);

    var polygonDrawer, markerDrawer, newLayers;

    // Add new element to the map
    LevelsMapService.newElement = function (layer) {
        newLayers = new L.FeatureGroup([layer]);
        MapService.addLayer(newLayers, layer);
    };

    // Enable creating new 'Area'
    LevelsMapService.enableAreaSelector = function () {
        var map = MapService.getMap();
        MapService.disableFullScreen();
        polygonDrawer = new L.Draw.Polygon(map, {
            shapeOptions: MapService.getLayerOptions('area')
        });
        polygonDrawer.enable();
    };

    // Enable adding new 'Beacon'
    LevelsMapService.enableBeaconDrawer = function () {
        var map = MapService.getMap();
        MapService.disableFullScreen();
        markerDrawer = new L.Draw.Marker(map, {icon: MapService.createMarkerIcon('beacon')});
        markerDrawer.enable();
    };

    // When cancel adding new element, remove it, disable modes, etc.
    LevelsMapService.cancelElement = function () {
        MapService.enableFullScreen();
        if (polygonDrawer) {
            polygonDrawer.disable();
        }
        if (markerDrawer) {
            markerDrawer.disable();
        }

        if (angular.isDefined(newLayers)) {
            newLayers.eachLayer(function (layer) {
                if (!layer.options.freshLayer) {
                    MapService.getMap().removeLayer(layer);
                }
            });
            newLayers = undefined;
        }
    };

    // Add already existing areas to the map (on init)
    LevelsMapService.addAreas = function (newAreas, level, editEnabled) {
        MapService.onResize(level, function () {
            angular.forEach(newAreas, function (area) {
                var latLngs = [];
                if (angular.isDefined(area.map_position)) {
                    angular.forEach(area.map_position, function (point) {
                        latLngs.push(MapService.pointToLatLng(point, level));
                    });
                } else {
                    throw new Error('Area has no points!');
                }
                var polygon = L.polygon(latLngs, MapService.getLayerOptions('area'));

                if (editEnabled) {
                    polygon.off().on('click', function () {
                        if (!MapService.isFullscreenOn()) {
                            $rootScope.$broadcast('areaEdit', area);
                        }
                    });
                }

                polygon.appsoup = area;

                MapService.addLayer(polygon);
                area._leaflet_id = polygon._leaflet_id;
            });
        });
    };

    // Add already existing beacons to the map (on init)
    LevelsMapService.addBeacons = function (newBeacons, level, editEnabled) {
        MapService.onResize(level, function () {
            angular.forEach(newBeacons, function (beacon) {
                var latLng = MapService.pointToLatLng(beacon.point_x_y, level),
                    beaconMarker = L.marker(latLng, {icon: MapService.createMarkerIcon('beacon')});

                if (editEnabled) {
                    beaconMarker.off().on('click', function () {
                        if (!MapService.isFullscreenOn()) {
                            $rootScope.$broadcast('beaconEdit', beacon);
                        }
                    });
                }

                // Tooltips For Beacons
                var popup = new L.Popup();
                popup.setContent('<p><b>' + beacon.name + '</b>');
                beaconMarker.bindPopup(popup, {autoPan: true, closeButton: false});

                beaconMarker.on('mouseover', function () {
                    this.openPopup();
                });

                beaconMarker.on('mouseout', function () {
                    this.closePopup();
                });

                beaconMarker.appsoup = beacon;

                MapService.addLayer(beaconMarker);
                beacon._leaflet_id = beaconMarker._leaflet_id;
            });
        });
    };

    // Remove element (area or beacon)
    LevelsMapService.removeElement = function (layerId) {
        MapService.removeLayer(layerId);
    };

    // Update element (area, beacon)
    LevelsMapService.updateElement = function (layerId, element, type) {
        if (angular.isDefined(layerId)) {
            MapService.getMap().eachLayer(function (layer) {
                if (layer._leaflet_id === layerId) {
                    element._leaflet_id = layer._leaflet_id;
                    layer.options.freshLayer = true;
                    layer.appsoup = element;
                    // bind onClick
                    layer.off().on('click', function () {
                        if (!MapService.isFullscreenOn()) {
                            $rootScope.$broadcast(type + 'Edit', element);
                        }
                    });
                }
            });
        } else {
            throw new Error('In order to update ' + type + ', layer ID is required!');
        }
        MapService.enableFullScreen();
    };

    // Check if beacon is within any area?
    LevelsMapService.checkBeaconArea = function (beacon, areas) {
        var possibleAreas = [];
        if (angular.isDefined(beacon)) {
            if (!angular.isObject(beacon)) {
                beacon = MapService.getLayer(beacon);
            }
            angular.forEach(areas, function (area) {
                var areaLayer = MapService.getLayer(area._leaflet_id);

                if (angular.isDefined(areaLayer)) {
                    var bounds = areaLayer.getBounds();
                    if (bounds.contains(beacon.getLatLng())) {
                        possibleAreas.push(area);
                    }
                }
            });
        } else {
            throw new Error('You must provide beacon layer or at least layer ID!');
        }

        return possibleAreas;
    };

    return LevelsMapService;
}]);

export default levelsMapService;
